import { normalize } from '../../hash-string';

export function normalizeIfNotNullOrEmpty(value: string | null) {
  return value && value.length > 0 ? normalize(value) : null;
}

export function toIsoDateIfNotNull(value: string | null) {
  if (value && value.length > 0) {
    const dateArray = value.split('/');
    if (dateArray.length === 3) {
      return `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`;
    }
    return null;
  }
  return null;
}
